import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Check, Gift } from 'lucide-react';
export function WhatsIncluded() {
  const tomos = [{
    name: 'Tomo 1 — Primeros pasos en el piano',
    value: '7.990'
  }, {
    name: 'Tomo 2 — Notas y melodías esenciales',
    value: '7.990'
  }, {
    name: 'Tomo 3 — Ritmo y coordinación',
    value: '6.990'
  }, {
    name: 'Tomo 4 — Canciones paso a paso',
    value: '6.990'
  }, {
    name: 'Tomo 5 — Técnica sin complicaciones',
    value: '5.990'
  }, {
    name: 'Tomo 6 — Repertorio completo',
    value: '5.990'
  }];
  const bonos = [{
    name: 'Guía de práctica diaria (15 min/día)',
    value: '3.390'
  }, {
    name: 'Planillas de seguimiento y progreso',
    value: '2.490'
  }, {
    name: 'Ejercicios de calentamiento express',
    value: '2.180'
  }];
  return <section className="py-20 bg-white" data-id="element-170">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-171">
        <FadeIn data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-navy mb-4" data-id="element-173">
            ¿Qué incluye Piano Fácil PRO?
          </h2>
          <p className="text-center text-navy/60 mb-12 text-lg" data-id="element-174">
            6 tomos completos + 3 bonos exclusivos
          </p>
        </FadeIn>

        {/* TOMOS */}
        <FadeIn data-id="element-175">
          <div className="bg-navy rounded-3xl p-8 md:p-12 text-white shadow-xl relative overflow-hidden mb-8" data-id="element-176">
            <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-177"></div>
            <div className="relative z-10" data-id="element-178">
              <div className="flex items-center gap-2 mb-2" data-id="element-179">
                <Check className="w-6 h-6 text-gold" data-id="element-180" />
                <h3 className="text-xl font-bold text-gold" data-id="element-181">
                  6 Tomos del Método Completo
                </h3>
              </div>
              <p className="text-beige/70 text-sm mb-8 ml-8" data-id="element-182">
                <span className="line-through" data-id="element-183">Total AR$ 49.990</span>
                <span className="mx-2" data-id="element-184">→</span>
                <span className="text-green-400 font-bold" data-id="element-185">
                  Solo por hoy a AR$ 19.990
                </span>
              </p>

              <div className="space-y-3" data-id="element-186">
                {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.08} direction="up" data-id="element-187">
                    <div className="flex items-center justify-between gap-4 bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-188">
                      <div className="flex items-center gap-3" data-id="element-189">
                        <div className="w-7 h-7 rounded-full bg-gold flex items-center justify-center flex-shrink-0" data-id="element-190">
                          <Check className="w-4 h-4 text-navy" strokeWidth={3} data-id="element-191" />
                        </div>
                        <span className="text-base md:text-lg font-medium" data-id="element-192">
                          {tomo.name}
                        </span>
                      </div>
                      <span className="text-sm text-white/40 line-through flex-shrink-0" data-id="element-193">
                        AR$ {tomo.value}
                      </span>
                    </div>
                  </FadeIn>)}
              </div>
            </div>
          </div>
        </FadeIn>

        {/* BONOS */}
        <FadeIn data-id="element-194">
          <div className="bg-gold/10 rounded-3xl p-8 md:p-12 shadow-lg relative overflow-hidden mb-8 border-2 border-emerald-300/50" data-id="element-195">
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-196"></div>
            <div className="relative z-10" data-id="element-197">
              <div className="flex items-center gap-2 mb-6" data-id="element-198">
                <Gift className="w-6 h-6 text-gold" data-id="element-199" />
                <h3 className="text-xl font-bold text-navy" data-id="element-200">
                  3 Bonos Exclusivos
                </h3>
              </div>

              <div className="space-y-3 mb-6" data-id="element-201">
                {bonos.map((bono, index) => <FadeIn key={index} delay={index * 0.08} direction="up" data-id="element-202">
                    <div className="flex items-center justify-between gap-4 bg-white p-4 rounded-xl border border-emerald-200" data-id="element-203">
                      <div className="flex items-center gap-3" data-id="element-204">
                        <div className="w-7 h-7 rounded-full bg-emerald-500 flex items-center justify-center flex-shrink-0" data-id="element-205">
                          <Gift className="w-4 h-4 text-white" strokeWidth={2.5} data-id="element-206" />
                        </div>
                        <span className="text-base md:text-lg font-medium text-navy" data-id="element-207">
                          {bono.name}
                        </span>
                      </div>
                      <span className="text-sm text-navy/40 line-through flex-shrink-0" data-id="element-208">
                        AR$ {bono.value}
                      </span>
                    </div>
                  </FadeIn>)}
              </div>

              <div className="bg-green-100 border border-green-300 rounded-xl p-4 text-center" data-id="element-209">
                <span className="text-green-700 font-bold text-lg" data-id="element-210">
                  🎁 GRATIS POR HOY
                </span>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Total */}
        <FadeIn delay={0.3} data-id="element-211">
          <div className="bg-navy rounded-2xl p-6 text-center border border-navy/20 shadow-lg" data-id="element-212">
            <p className="text-beige/70 text-lg mb-1" data-id="element-213">
              Valor total de todo el contenido:
            </p>
            <p className="text-2xl text-white/50 line-through mb-2" data-id="element-214">
              AR$ 49.990
            </p>
            <p className="text-3xl md:text-4xl font-bold text-gold" data-id="element-215">
              Hoy te lo llevás por AR$ 19.990
            </p>
            <p className="text-green-400 font-bold mt-2" data-id="element-216">
              ¡Ahorrás AR$ 30.000!
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}